/* src/app/modules/shared/components/attachment-viewer/attachment-viewer.component.scss */
/*# sourceMappingURL=attachment-viewer.component.css.map */
